<script>
  import ModalButtons from 'root/services/modals/ModalButtons.Close.svelte';
  import ClosableModal from 'root/services/modals/Closable.modal.svelte';
  import {rfpManagerRepository, httpErrorHandler} from 'root/angular-injector-provider';
  import orderBy from 'lodash/orderBy';
  import SpinnerWithText from 'root/components/molecules/SpinnerWithText.svelte';
  import UserDetailsHeader from 'vRoot/account-profile/modules/manage-users/UserDetailsHeader.svelte';

  export let cancel, userAccount;

  const LOADING = 'LOADING';

  let companies = LOADING;

  (function initialize(){
    rfpManagerRepository().listAllCompanies()
      .then(response => {
        const accounts = companies = response.data
          .filter(a => a.type === 'COMPANY' && userAccount.managedAccounts.includes(a.id))
        companies = orderBy(accounts, ['managedByUser', 'name'], ['desc', 'asc']);
      })
      .catch(error => httpErrorHandler().handle(error));
  })();

</script>


<ClosableModal width="650px" close="{cancel}">
  <div slot="heading">
    <UserDetailsHeader
      {userAccount}
      userType="{userAccount.type}"
    />
  </div>

  {#if companies === LOADING}
    <div class="Notification">
      <SpinnerWithText />
    </div>
  {:else if !companies.length}
    <div class="Notification">
      There are no companies to assign!
    </div>
  {:else}
    <div class="Body">
      <div class="CompaniesHeader">
        <span>
          {#if companies.length}
            User is assigned to { companies.length } Compan{ companies.length > 1? 'ies': 'y' }
          {:else}
            User is not assigned to any company
          {/if}
        </span>
        <span>User Assigned:</span>
      </div>


      <div class="Companies">
        {#each companies as company}
          <div
            class="Company"
            class:ManagedByUser={company.managedByUser}
          >
            <div class="CompanyName">{company.name}</div>

            <div class="CompanyAgent">
              {#if company.primaryAgent && company.primaryAgent.userDetails}
                <span>{company.primaryAgent.userDetails.fullName}</span>
              {/if}
            </div>
          </div>
        {/each}
      </div>
    </div>
  {/if}

  <ModalButtons action="{cancel}" />
</ClosableModal>

<style lang="stylus">

  .Notification {
    padding: 20px;
    font-size: 14px;
    font-weight: bold;
    color #546E7A;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .Body {
    margin-top: 15px;
    margin-bottom: 15px;
    padding: 0 15px;
    color #546E7A;
    font-size 13px;
  }

  .CompaniesHeader {
    display flex;
    justify-content space-between;
    align-items center;
    padding 5px;
  }

  .Companies {
    overflow: auto;
    max-height: 50vh;
    border: 1px solid #B0BEC5;
    border-radius: 5px;
  }

  .Company {
    padding: 10px;
    height: 42px;
    border-bottom: 1px solid #eceff1;
    display: flex;
    align-items: center;
    cursor: pointer;
    box-sizing: border-box;
  }

  .CompanyName {
    margin-left: 5px;
    white-space: nowrap;
  }

  .CompanyAgent {
    flex: 1 1 100%;
    white-space: nowrap;
    text-align: right;
  }

</style>
